import { ReactNodeViewRenderer } from "@tiptap/react"

import { BaseAttachmentNode } from "../BaseAttachment/extension"
import { AssetAttachmentNodeComponent } from "./Component"

export const AssetAttachmentNode = BaseAttachmentNode.extend({
	addNodeView() {
		return ReactNodeViewRenderer(AssetAttachmentNodeComponent)
	},
})
